import * as s from "react";
import { composeEventHandlers as g } from "../../../../../@radix-ui_primitive@1.1.3/bundled_deps/@radix-ui/primitive/dist/index.js";
import { useComposedRefs as H } from "../../../../../@radix-ui_react-compose-refs@1.1.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-compose-refs/dist/index.js";
import { createContextScope as K } from "../../../../../@radix-ui_react-context@1.1.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-context/dist/index.js";
import { DismissableLayer as W } from "../../../../../@radix-ui_react-dismissable-layer@1.1.11_@types_react-dom@19.2.3_@types_react@19.2.14___3d3960154a4c07d09bb90cb341135fc5/bundled_deps/@radix-ui/react-dismissable-layer/dist/index.js";
import { useId as $ } from "../../../../../@radix-ui_react-id@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-id/dist/index.js";
import { createPopperScope as N, Root as z, Anchor as J, Content as Q, Arrow as Z } from "../../../../../@radix-ui_react-popper@1.2.8_@types_react-dom@19.2.3_@types_react@19.2.14__@types_react_13e0521d8aea7ebfbfb8bee1fb615c05/bundled_deps/@radix-ui/react-popper/dist/index.js";
import { Portal as ee } from "../../../../../@radix-ui_react-portal@1.1.9_@types_react-dom@19.2.3_@types_react@19.2.14__@types_react_7668895bec2444446faa4e0f4eb5244b/bundled_deps/@radix-ui/react-portal/dist/index.js";
import { Presence as S } from "../../../../../@radix-ui_react-presence@1.1.5_@types_react-dom@19.2.3_@types_react@19.2.14__@types_rea_c01c26c80b5ab5e3ecefbda6eca51ad1/bundled_deps/@radix-ui/react-presence/dist/index.js";
import { Primitive as te } from "../../../../../@radix-ui_react-primitive@2.1.3_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_1181ea5061ec9212248424669240e4ec/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { createSlottable as oe } from "../../../../../@radix-ui_react-slot@1.2.3_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-slot/dist/index.js";
import { useControllableState as re } from "../../../../../@radix-ui_react-use-controllable-state@1.2.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-controllable-state/dist/index.js";
import { Root as ne } from "../../../../../@radix-ui_react-visually-hidden@1.2.3_@types_react-dom@19.2.3_@types_react@19.2.14__@ty_fa89646d7248b32d1762bf88948f6339/bundled_deps/@radix-ui/react-visually-hidden/dist/index.js";
import { j as p } from "../../../../../../../_virtual/jsx-runtime.js";
var [O] = K("Tooltip", [
  N
]), D = N(), G = "TooltipProvider", se = 700, j = "tooltip.open", [ie, A] = O(G), F = (t) => {
  const {
    __scopeTooltip: o,
    delayDuration: e = se,
    skipDelayDuration: r = 300,
    disableHoverableContent: n = !1,
    children: c
  } = t, a = s.useRef(!0), v = s.useRef(!1), i = s.useRef(0);
  return s.useEffect(() => {
    const d = i.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ p.jsx(
    ie,
    {
      scope: o,
      isOpenDelayedRef: a,
      delayDuration: e,
      onOpen: s.useCallback(() => {
        window.clearTimeout(i.current), a.current = !1;
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(i.current), i.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: v,
      onPointerInTransitChange: s.useCallback((d) => {
        v.current = d;
      }, []),
      disableHoverableContent: n,
      children: c
    }
  );
};
F.displayName = G;
var R = "Tooltip", [ae, _] = O(R), B = (t) => {
  const {
    __scopeTooltip: o,
    children: e,
    open: r,
    defaultOpen: n,
    onOpenChange: c,
    disableHoverableContent: a,
    delayDuration: v
  } = t, i = A(R, t.__scopeTooltip), d = D(o), [l, f] = s.useState(null), h = $(), u = s.useRef(0), x = a ?? i.disableHoverableContent, T = v ?? i.delayDuration, m = s.useRef(!1), [y, C] = re({
    prop: r,
    defaultProp: n ?? !1,
    onChange: (I) => {
      I ? (i.onOpen(), document.dispatchEvent(new CustomEvent(j))) : i.onClose(), c?.(I);
    },
    caller: R
  }), w = s.useMemo(() => y ? m.current ? "delayed-open" : "instant-open" : "closed", [y]), P = s.useCallback(() => {
    window.clearTimeout(u.current), u.current = 0, m.current = !1, C(!0);
  }, [C]), E = s.useCallback(() => {
    window.clearTimeout(u.current), u.current = 0, C(!1);
  }, [C]), M = s.useCallback(() => {
    window.clearTimeout(u.current), u.current = window.setTimeout(() => {
      m.current = !0, C(!0), u.current = 0;
    }, T);
  }, [T, C]);
  return s.useEffect(() => () => {
    u.current && (window.clearTimeout(u.current), u.current = 0);
  }, []), /* @__PURE__ */ p.jsx(z, { ...d, children: /* @__PURE__ */ p.jsx(
    ae,
    {
      scope: o,
      contentId: h,
      open: y,
      stateAttribute: w,
      trigger: l,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        i.isOpenDelayedRef.current ? M() : P();
      }, [i.isOpenDelayedRef, M, P]),
      onTriggerLeave: s.useCallback(() => {
        x ? E() : (window.clearTimeout(u.current), u.current = 0);
      }, [E, x]),
      onOpen: P,
      onClose: E,
      disableHoverableContent: x,
      children: e
    }
  ) });
};
B.displayName = R;
var L = "TooltipTrigger", U = s.forwardRef(
  (t, o) => {
    const { __scopeTooltip: e, ...r } = t, n = _(L, e), c = A(L, e), a = D(e), v = s.useRef(null), i = H(o, v, n.onTriggerChange), d = s.useRef(!1), l = s.useRef(!1), f = s.useCallback(() => d.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ p.jsx(J, { asChild: !0, ...a, children: /* @__PURE__ */ p.jsx(
      te.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...r,
        ref: i,
        onPointerMove: g(t.onPointerMove, (h) => {
          h.pointerType !== "touch" && !l.current && !c.isPointerInTransitRef.current && (n.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: g(t.onPointerLeave, () => {
          n.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: g(t.onPointerDown, () => {
          n.open && n.onClose(), d.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: g(t.onFocus, () => {
          d.current || n.onOpen();
        }),
        onBlur: g(t.onBlur, n.onClose),
        onClick: g(t.onClick, n.onClose)
      }
    ) });
  }
);
U.displayName = L;
var k = "TooltipPortal", [ce, le] = O(k, {
  forceMount: void 0
}), V = (t) => {
  const { __scopeTooltip: o, forceMount: e, children: r, container: n } = t, c = _(k, o);
  return /* @__PURE__ */ p.jsx(ce, { scope: o, forceMount: e, children: /* @__PURE__ */ p.jsx(S, { present: e || c.open, children: /* @__PURE__ */ p.jsx(ee, { asChild: !0, container: n, children: r }) }) });
};
V.displayName = k;
var b = "TooltipContent", Y = s.forwardRef(
  (t, o) => {
    const e = le(b, t.__scopeTooltip), { forceMount: r = e.forceMount, side: n = "top", ...c } = t, a = _(b, t.__scopeTooltip);
    return /* @__PURE__ */ p.jsx(S, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ p.jsx(q, { side: n, ...c, ref: o }) : /* @__PURE__ */ p.jsx(ue, { side: n, ...c, ref: o }) });
  }
), ue = s.forwardRef((t, o) => {
  const e = _(b, t.__scopeTooltip), r = A(b, t.__scopeTooltip), n = s.useRef(null), c = H(o, n), [a, v] = s.useState(null), { trigger: i, onClose: d } = e, l = n.current, { onPointerInTransitChange: f } = r, h = s.useCallback(() => {
    v(null), f(!1);
  }, [f]), u = s.useCallback(
    (x, T) => {
      const m = x.currentTarget, y = { x: x.clientX, y: x.clientY }, C = he(y, m.getBoundingClientRect()), w = xe(y, C), P = me(T.getBoundingClientRect()), E = Ce([...w, ...P]);
      v(E), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => h(), [h]), s.useEffect(() => {
    if (i && l) {
      const x = (m) => u(m, l), T = (m) => u(m, i);
      return i.addEventListener("pointerleave", x), l.addEventListener("pointerleave", T), () => {
        i.removeEventListener("pointerleave", x), l.removeEventListener("pointerleave", T);
      };
    }
  }, [i, l, u, h]), s.useEffect(() => {
    if (a) {
      const x = (T) => {
        const m = T.target, y = { x: T.clientX, y: T.clientY }, C = i?.contains(m) || l?.contains(m), w = !Te(y, a);
        C ? h() : w && (h(), d());
      };
      return document.addEventListener("pointermove", x), () => document.removeEventListener("pointermove", x);
    }
  }, [i, l, a, d, h]), /* @__PURE__ */ p.jsx(q, { ...t, ref: c });
}), [pe, de] = O(R, { isInside: !1 }), fe = oe("TooltipContent"), q = s.forwardRef(
  (t, o) => {
    const {
      __scopeTooltip: e,
      children: r,
      "aria-label": n,
      onEscapeKeyDown: c,
      onPointerDownOutside: a,
      ...v
    } = t, i = _(b, e), d = D(e), { onClose: l } = i;
    return s.useEffect(() => (document.addEventListener(j, l), () => document.removeEventListener(j, l)), [l]), s.useEffect(() => {
      if (i.trigger) {
        const f = (h) => {
          h.target?.contains(i.trigger) && l();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [i.trigger, l]), /* @__PURE__ */ p.jsx(
      W,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: c,
        onPointerDownOutside: a,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ p.jsxs(
          Q,
          {
            "data-state": i.stateAttribute,
            ...d,
            ...v,
            ref: o,
            style: {
              ...v.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ p.jsx(fe, { children: r }),
              /* @__PURE__ */ p.jsx(pe, { scope: e, isInside: !0, children: /* @__PURE__ */ p.jsx(ne, { id: i.contentId, role: "tooltip", children: n || r }) })
            ]
          }
        )
      }
    );
  }
);
Y.displayName = b;
var X = "TooltipArrow", ve = s.forwardRef(
  (t, o) => {
    const { __scopeTooltip: e, ...r } = t, n = D(e);
    return de(
      X,
      e
    ).isInside ? null : /* @__PURE__ */ p.jsx(Z, { ...n, ...r, ref: o });
  }
);
ve.displayName = X;
function he(t, o) {
  const e = Math.abs(o.top - t.y), r = Math.abs(o.bottom - t.y), n = Math.abs(o.right - t.x), c = Math.abs(o.left - t.x);
  switch (Math.min(e, r, n, c)) {
    case c:
      return "left";
    case n:
      return "right";
    case e:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function xe(t, o, e = 5) {
  const r = [];
  switch (o) {
    case "top":
      r.push(
        { x: t.x - e, y: t.y + e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x + e, y: t.y - e }
      );
      break;
    case "left":
      r.push(
        { x: t.x + e, y: t.y - e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "right":
      r.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x - e, y: t.y + e }
      );
      break;
  }
  return r;
}
function me(t) {
  const { top: o, right: e, bottom: r, left: n } = t;
  return [
    { x: n, y: o },
    { x: e, y: o },
    { x: e, y: r },
    { x: n, y: r }
  ];
}
function Te(t, o) {
  const { x: e, y: r } = t;
  let n = !1;
  for (let c = 0, a = o.length - 1; c < o.length; a = c++) {
    const v = o[c], i = o[a], d = v.x, l = v.y, f = i.x, h = i.y;
    l > r != h > r && e < (f - d) * (r - l) / (h - l) + d && (n = !n);
  }
  return n;
}
function Ce(t) {
  const o = t.slice();
  return o.sort((e, r) => e.x < r.x ? -1 : e.x > r.x ? 1 : e.y < r.y ? -1 : e.y > r.y ? 1 : 0), ye(o);
}
function ye(t) {
  if (t.length <= 1) return t.slice();
  const o = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    for (; o.length >= 2; ) {
      const c = o[o.length - 1], a = o[o.length - 2];
      if ((c.x - a.x) * (n.y - a.y) >= (c.y - a.y) * (n.x - a.x)) o.pop();
      else break;
    }
    o.push(n);
  }
  o.pop();
  const e = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const n = t[r];
    for (; e.length >= 2; ) {
      const c = e[e.length - 1], a = e[e.length - 2];
      if ((c.x - a.x) * (n.y - a.y) >= (c.y - a.y) * (n.x - a.x)) e.pop();
      else break;
    }
    e.push(n);
  }
  return e.pop(), o.length === 1 && e.length === 1 && o[0].x === e[0].x && o[0].y === e[0].y ? o : o.concat(e);
}
var Me = F, Ie = B, He = U, Ne = V, Se = Y;
export {
  Se as Content,
  Ne as Portal,
  Me as Provider,
  Ie as Root,
  B as Tooltip,
  ve as TooltipArrow,
  Y as TooltipContent,
  V as TooltipPortal,
  F as TooltipProvider,
  U as TooltipTrigger,
  He as Trigger
};
